/*
 * @Author: your name
 * @Date: 2022-10-18 10:58:58
 * @LastEditors: Gyan
 * @Description: 项目门户路由
 * @FilePath: \dhr_frontend\src\routes\modules\projectPortal.js
 */
import blankPage from "@/components/blankPage/index.vue";
export default [
  {
    name: "projectPortal",
    path: "/projectPortal",
    component: blankPage,
    redirect: {
      name: "articleIndex",
    },
    children: [
      {
        name: "articleIndex",
        path: "articleIndex",
        component: () => import("@/views/projectPortal/article/index.vue"),
        meta: {
          title: "文章管理列表",
        },
      },
      {
        name: 'articleAdd',
        path: 'articleAdd',
        component: () => import('@/views/projectPortal/article/add.vue'),
        meta: {
          parentAuth: '/projectPortal/articleIndex',
          title: '新建文章'
        }
      },
      {
        name: 'articleEdit',
        path: 'articleEdit',
        component: () => import('@/views/projectPortal/article/add.vue'),
        meta: {
          parentAuth: '/projectPortal/articleIndex',
          title: '编辑文章'
        }
      },
      {
        name: "goodBookRecommend",
        path: "goodBookRecommend",
        component: () => import("@/views/projectPortal/goodBookRecommend.vue"),
        meta: {
          title: "好书推荐",
        },
      },
      {
        name: "tmplateManagement",
        path: "tmplateManagement",
        component: () =>
          import("@/views/projectPortal/tmplateManagement.vue"),
        meta: {
          title: "模板管理",
        },
        props: (route) => ({
          pageType: 'template'
        })
      },
      {
        name: "knowledgeSharing",
        path: "knowledgeSharing",
        component: () =>
          import("@/views/projectPortal/tmplateManagement.vue"),
        meta: {
          title: "知识分享",
        },
        props: (route) => ({
          pageType: 'knowledge'
        })
      },
      {
        name: "commendationManagement",
        path: "commendationManagement",
        component: () => import("@/views/projectPortal/commendationManagement.vue"),
        meta: {
          title: "荣誉榜",
        },
      },
      {
        name: "keyProjectManagement",
        path: "keyProjectManagement",
        component: () => import("@/views/projectPortal/keyProjectManagement.vue"),
        meta: {
          title: "重点项目管理",
        },
      },
      {
        name: "groupBoard",
        path: "groupBoard",
        component: () => import("@/views/projectPortal/groupBoard.vue"),
        meta: {
          title: "集团看板",
        },
      },
      {
        name: 'videoCourses',
        path: 'videoCourses',
        component: () => import('@/views/projectPortal/videoCourses.vue'),
        meta: {
          title: "视频课程",
        },
      },
      {
        name: 'majorEvents',
        path: 'majorEvents',
        component: () => import('@/views/projectPortal/majorEvents.vue'),
        meta: {
          title: "经管大事件",
        },
      },
      {
        name: 'projectPortalBannerManagement',
        path: 'bannerManagement',
        component: () => import('@/views/projectPortal/bannerManagement.vue'),
        meta: {
          title: "banner管理",
        }
      },
      {
        name: 'painSpotFeedback',
        path: 'painSpotFeedback',
        component: () => import('@/views/projectPortal/painSpotFeedback.vue'),
        meta: {
          title: '业务反馈'
        }
      },
      {
        name: 'painSpotFeedbackDetail',
        path: 'painSpotFeedbackDetail',
        component: () => import('@/views/projectPortal/painSpotDetail.vue'),
        meta: {
          title: '反馈详情',
          parentAuth: '/projectPortal/painSpotFeedback'
        },
        props: (route) => ({
          painId: route.query.painId,
          defaultType: 'check'
        })
      },
      {
        name: 'painSpotReleaseRecord',
        path: 'painSpotReleaseRecord',
        component: () => import('@/views/projectPortal/painSpotReleaseRecord.vue'),
        meta: {
          title: '发布记录'
        }
      },
      {
        name: 'painSpotReleaseRecordDetail',
        path: 'painSpotReleaseRecordDetail/:id?',
        component: () => import('@/views/projectPortal/painSpotDetail.vue'),
        meta: {
          title: '记录详情',
          parentAuth: '/projectPortal/painSpotReleaseRecord'
        },
        props: (route) => ({
          id: route.params.id,
          painId: route.query.painId,
          defaultType: 'form',
          defaultForm: route.params.defaultForm //默认表单数据，不记录在url中
        })
      }
    ],
  },
];
